"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7.162 10l9.154 3.052a1 1 0 01-.632 1.897l-12-4c-.912-.304-.912-1.594 0-1.897l12-4a1 1 0 01.632 1.897L7.162 10z"];
//# sourceMappingURL=less-than.js.map